import styles from './SoundButton.module.sass';
import {useGameContext} from "@/context/GameContext";
import Image from "next/image";

import cn from "classnames";
const SoundButton = ({ ...props }) => {

	const {isSoundMuted, setIsSoundMuted} = useGameContext();

	const handleSoundClick = () => {
		setIsSoundMuted(!isSoundMuted);

	}

	return (
		<div className={cn(styles.sound_btn, 'custom_pointer')} {...props} onClick={handleSoundClick}>
			<Image src={'/images/Game/SoundButton/sound_on.png'} alt={"Sound ON"} className={cn(styles.sound_on, {[styles.current]: !isSoundMuted})} width={190} height={144}/>
			<Image src={'/images/Game/SoundButton/sound_off.png'} alt={"Sound OFF"} className={cn(styles.sound_off, {[styles.current]: isSoundMuted})} width={196} height={144}/>
		</div>
	)
}

export default SoundButton;